// İSG uzmanı portalı — ortak create / bağlantı yüzeylerinin (`PersonnelCreateSheet`, `PersonnelLinkModal`) bağı (GL6).
// Uçlar §4.2–§4.4 (EP). Anahtarlar taşeron uuid'i taşır: başka taşeronun satırı önbellekten sunulamaz.
import { type PersonnelActivationClient, contractorsApi } from '@isgportal/shared';
import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { contractorsKeys } from './contractorsKeys';
import { permitsKeys } from './permitsKeys';

export function usePersonnelActivationClient(contractorUuid: string): PersonnelActivationClient {
  const queryClient = useQueryClient();
  return useMemo<PersonnelActivationClient>(
    () => ({
      create: (body) => contractorsApi.createPersonnel(contractorUuid, body),
      sendLink: (userUuid, body) =>
        contractorsApi.sendActivationLink(contractorUuid, userUuid, body),
      resend: (invitationUuid, body) =>
        contractorsApi.resendActivationLink(contractorUuid, invitationUuid, body),
      cancel: (invitationUuid) => contractorsApi.revokeInvitation(contractorUuid, invitationUuid),
      invalidate: () => {
        queryClient.invalidateQueries({ queryKey: contractorsKeys.personnel(contractorUuid) });
        queryClient.invalidateQueries({ queryKey: permitsKeys.personnelOptions(contractorUuid) });
      },
    }),
    [contractorUuid, queryClient],
  );
}
